import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #TEXT-PASSAGE
\*------------------------------------ */
/**
 * 1) A passage of text  (e.g. article, blog post), including uncontrolled elements
 *    (e.g. unclassed h2, h3, ul, li, and so on).
 * 2) Use this file only for styling text passage and elements inside of text passage.
 */
cat-text-passage {
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
  /**
  * Reset paragraph margins
  */
  /**
  * Vertical spacing within extra small text passage
  */
  /**
  * Generic h1 within text passage
  */
  /**
  * Generic h2 within text passage
  */
  /**
  * Generic h3 within text passage
  */
  /**
  * Generic h4 within text passage
  */
  /**
  * Generic h5 within text passage
  */
  /**
  * Generic h6 within text passage
  */
  /**
  * Generic unordered and ordered lists within text passage
  */
  /**
  * Unordered list within text passage
  */
  /**
  * Ordered list within text passage
  */
  /**
  * Generic link tag within text passage
  */
  /**
  * Blockquote within text passage
  */
  /**
  * Last item declared in the text passage
  * 1) Remove default margin bottom from the item
  */
}
cat-text-passage p {
  margin: 0;
}
cat-text-passage * + * {
  margin-block-start: var(--cat-space-x-large);
}
cat-text-passage h1 {
  margin-block-end: var(--cat-space-small);
  font-family: var(--cat-theme-typography-display-lg-font-family);
  font-weight: var(--cat-theme-typography-display-lg-font-weight);
  font-size: var(--cat-theme-typography-display-lg-font-size);
  line-height: var(--cat-theme-typography-display-lg-line-height);
}
@media all and (width <= calc(48rem - 0.02px)) {
  cat-text-passage h1 {
    font-size: var(--cat-theme-typography-display-lg-mobile-font-size);
    line-height: var(--cat-theme-typography-display-lg-mobile-line-height);
  }
}
cat-text-passage h2 {
  margin-block-end: var(--cat-space-small);
  font-family: var(--cat-theme-typography-display-font-family);
  font-weight: var(--cat-theme-typography-display-font-weight);
  font-size: var(--cat-theme-typography-display-font-size);
  line-height: var(--cat-theme-typography-display-line-height);
}
@media all and (width <= calc(48rem - 0.02px)) {
  cat-text-passage h2 {
    font-size: var(--cat-theme-typography-display-mobile-font-size);
    line-height: var(--cat-theme-typography-display-mobile-line-height);
  }
}
cat-text-passage h3 {
  margin-block-end: var(--cat-space-small);
  font-family: var(--cat-theme-typography-headline-lg-font-family);
  font-weight: var(--cat-theme-typography-headline-lg-font-weight);
  font-size: var(--cat-theme-typography-headline-lg-font-size);
  line-height: var(--cat-theme-typography-headline-lg-line-height);
}
@media all and (width <= calc(48rem - 0.02px)) {
  cat-text-passage h3 {
    font-size: var(--cat-theme-typography-headline-lg-mobile-font-size);
    line-height: var(--cat-theme-typography-headline-lg-mobile-line-height);
  }
}
cat-text-passage h4 {
  margin-block-end: var(--cat-space-small);
  font-family: var(--cat-theme-typography-headline-font-family);
  font-weight: var(--cat-theme-typography-headline-font-weight);
  font-size: var(--cat-theme-typography-headline-font-size);
  line-height: var(--cat-theme-typography-headline-line-height);
}
@media all and (width <= calc(48rem - 0.02px)) {
  cat-text-passage h4 {
    font-size: var(--cat-theme-typography-headline-mobile-font-size);
    line-height: var(--cat-theme-typography-headline-mobile-line-height);
  }
}
cat-text-passage h5 {
  margin-block-end: var(--cat-space-small);
  font-family: var(--cat-theme-typography-title-font-family);
  font-weight: var(--cat-theme-typography-title-font-weight);
  font-size: var(--cat-theme-typography-title-font-size);
  line-height: var(--cat-theme-typography-title-line-height);
}
@media all and (width <= calc(48rem - 0.02px)) {
  cat-text-passage h5 {
    font-size: var(--cat-theme-typography-title-mobile-font-size);
    line-height: var(--cat-theme-typography-title-mobile-line-height);
  }
}
cat-text-passage h6 {
  margin-block-end: var(--cat-space-small);
  font-family: var(--cat-theme-typography-title-font-family);
  font-weight: var(--cat-theme-typography-title-font-weight);
  font-size: var(--cat-theme-typography-title-font-size);
  line-height: var(--cat-theme-typography-title-line-height);
}
@media all and (width <= calc(48rem - 0.02px)) {
  cat-text-passage h6 {
    font-size: var(--cat-theme-typography-title-mobile-font-size);
    line-height: var(--cat-theme-typography-title-mobile-line-height);
  }
}
cat-text-passage ul,
cat-text-passage ol {
  margin-block-start: 0;
}
cat-text-passage ul {
  margin-inline-start: calc(var(--size-base-unit) * 2.5);
  padding-inline-start: 0;
}
cat-text-passage ol {
  margin-inline-start: var(--cat-space-large);
  padding-inline-start: 0;
}
cat-text-passage a {
  color: var(--cat-theme-color-content-brand);
  text-decoration: none;
}
cat-text-passage a:hover, cat-text-passage a:focus {
  text-decoration: underline;
}
cat-text-passage blockquote {
  font-style: italic;
  border-inline-start: var(--cat-border-width-sm) solid var(--cat-theme-color-border-default);
  color: var(--cat-theme-color-content-default);
  padding-inline-start: var(--cat-space-medium);
  margin-inline-start: 0;
  margin-block-end: var(--cat-space-medium);
}
cat-text-passage :last-child {
  margin-block-end: 0;
}

/**
* Small text passage
* 1) Class names are needed to allow variant to work in React wrapper when attributes
*/
cat-text-passage[size=sm],
.cat-text-passage--sm {
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
  /**
  * Vertical spacing within small text passage
  */
  /**
  * Unordered list within small text passage
  */
  /**
  * Ordered list within small text passage
  */
  /**
  * Generic h1 within text passage
  */
  /**
  * Generic h2 within text passage
  */
  /**
  * Generic h3 within text passage
  */
  /**
  * Generic h4 within text passage
  */
}
cat-text-passage[size=sm] * + *,
.cat-text-passage--sm * + * {
  margin-block-start: var(--cat-space-medium);
}
cat-text-passage[size=sm] ul,
.cat-text-passage--sm ul {
  margin-inline-start: var(--cat-space-large);
  padding-inline-start: 0;
}
cat-text-passage[size=sm] ol,
.cat-text-passage--sm ol {
  margin-inline-start: var(--cat-space-medium);
  padding-inline-start: 0;
}
cat-text-passage[size=sm] h1,
.cat-text-passage--sm h1 {
  margin-block-end: var(--cat-space-small);
  font-family: var(--cat-theme-typography-display-font-family);
  font-weight: var(--cat-theme-typography-display-font-weight);
  font-size: var(--cat-theme-typography-display-font-size);
  line-height: var(--cat-theme-typography-display-line-height);
}
@media all and (width <= calc(48rem - 0.02px)) {
  cat-text-passage[size=sm] h1,
  .cat-text-passage--sm h1 {
    font-size: var(--cat-theme-typography-display-mobile-font-size);
    line-height: var(--cat-theme-typography-display-mobile-line-height);
  }
}
cat-text-passage[size=sm] h2,
.cat-text-passage--sm h2 {
  margin-block-end: var(--cat-space-small);
  font-family: var(--cat-theme-typography-headline-lg-font-family);
  font-weight: var(--cat-theme-typography-headline-lg-font-weight);
  font-size: var(--cat-theme-typography-headline-lg-font-size);
  line-height: var(--cat-theme-typography-headline-lg-line-height);
}
@media all and (width <= calc(48rem - 0.02px)) {
  cat-text-passage[size=sm] h2,
  .cat-text-passage--sm h2 {
    font-size: var(--cat-theme-typography-headline-lg-mobile-font-size);
    line-height: var(--cat-theme-typography-headline-lg-mobile-line-height);
  }
}
cat-text-passage[size=sm] h3,
.cat-text-passage--sm h3 {
  margin-block-end: var(--cat-space-small);
  font-family: var(--cat-theme-typography-headline-font-family);
  font-weight: var(--cat-theme-typography-headline-font-weight);
  font-size: var(--cat-theme-typography-headline-font-size);
  line-height: var(--cat-theme-typography-headline-line-height);
}
@media all and (width <= calc(48rem - 0.02px)) {
  cat-text-passage[size=sm] h3,
  .cat-text-passage--sm h3 {
    font-size: var(--cat-theme-typography-headline-mobile-font-size);
    line-height: var(--cat-theme-typography-headline-mobile-line-height);
  }
}
cat-text-passage[size=sm] h4,
.cat-text-passage--sm h4 {
  margin-block-end: var(--cat-space-small);
  font-family: var(--cat-theme-typography-title-font-family);
  font-weight: var(--cat-theme-typography-title-font-weight);
  font-size: var(--cat-theme-typography-title-font-size);
  line-height: var(--cat-theme-typography-title-line-height);
}
@media all and (width <= calc(48rem - 0.02px)) {
  cat-text-passage[size=sm] h4,
  .cat-text-passage--sm h4 {
    font-size: var(--cat-theme-typography-title-mobile-font-size);
    line-height: var(--cat-theme-typography-title-mobile-line-height);
  }
}

/**
* Extra small text passage
* 1) Class names are needed to allow variant to work in React wrapper when attributes
*/
cat-text-passage[size=xs],
.cat-text-passage--xs {
  font-family: var(--cat-theme-typography-footnote-font-family);
  font-weight: var(--cat-theme-typography-footnote-font-weight);
  font-size: var(--cat-theme-typography-footnote-font-size);
  line-height: var(--cat-theme-typography-footnote-line-height);
  /**
  * Vertical spacing within extra small text passage
  */
  /**
  * Unordered list within extra small text passage
  */
  /**
  * Ordered list within extra small text passage
  */
  /**
  * Generic h1 within text passage
  */
  /**
  * Generic h2 within text passage
  */
  /**
  * Generic h3 within text passage
  */
  /**
  * Generic h4 within text passage
  */
  /**
  * Status list style
  * @TODO - Does this belong here or should it be its own component?
  */
}
cat-text-passage[size=xs] * + *,
.cat-text-passage--xs * + * {
  margin-block-start: var(--cat-space-x-small);
}
cat-text-passage[size=xs] ul,
.cat-text-passage--xs ul {
  margin-inline-start: calc(var(--size-base-unit) * 1.25);
  padding-inline-start: 0;
}
cat-text-passage[size=xs] ol,
.cat-text-passage--xs ol {
  margin-inline-start: var(--cat-space-x-small);
  padding-inline-start: 0;
}
cat-text-passage[size=xs] h1,
.cat-text-passage--xs h1 {
  margin-block-end: var(--cat-space-small);
  font-family: var(--cat-theme-typography-display-font-family);
  font-weight: var(--cat-theme-typography-display-font-weight);
  font-size: var(--cat-theme-typography-display-font-size);
  line-height: var(--cat-theme-typography-display-line-height);
}
@media all and (width <= calc(48rem - 0.02px)) {
  cat-text-passage[size=xs] h1,
  .cat-text-passage--xs h1 {
    font-size: var(--cat-theme-typography-display-mobile-font-size);
    line-height: var(--cat-theme-typography-display-mobile-line-height);
  }
}
cat-text-passage[size=xs] h2,
.cat-text-passage--xs h2 {
  margin-block-end: var(--cat-space-small);
  font-family: var(--cat-theme-typography-headline-lg-font-family);
  font-weight: var(--cat-theme-typography-headline-lg-font-weight);
  font-size: var(--cat-theme-typography-headline-lg-font-size);
  line-height: var(--cat-theme-typography-headline-lg-line-height);
}
@media all and (width <= calc(48rem - 0.02px)) {
  cat-text-passage[size=xs] h2,
  .cat-text-passage--xs h2 {
    font-size: var(--cat-theme-typography-headline-lg-mobile-font-size);
    line-height: var(--cat-theme-typography-headline-lg-mobile-line-height);
  }
}
cat-text-passage[size=xs] h3,
.cat-text-passage--xs h3 {
  margin-block-end: var(--cat-space-small);
  font-family: var(--cat-theme-typography-headline-font-family);
  font-weight: var(--cat-theme-typography-headline-font-weight);
  font-size: var(--cat-theme-typography-headline-font-size);
  line-height: var(--cat-theme-typography-headline-line-height);
}
@media all and (width <= calc(48rem - 0.02px)) {
  cat-text-passage[size=xs] h3,
  .cat-text-passage--xs h3 {
    font-size: var(--cat-theme-typography-headline-mobile-font-size);
    line-height: var(--cat-theme-typography-headline-mobile-line-height);
  }
}
cat-text-passage[size=xs] h4,
.cat-text-passage--xs h4 {
  margin-block-end: var(--cat-space-small);
  font-family: var(--cat-theme-typography-title-font-family);
  font-weight: var(--cat-theme-typography-title-font-weight);
  font-size: var(--cat-theme-typography-title-font-size);
  line-height: var(--cat-theme-typography-title-line-height);
}
@media all and (width <= calc(48rem - 0.02px)) {
  cat-text-passage[size=xs] h4,
  .cat-text-passage--xs h4 {
    font-size: var(--cat-theme-typography-title-mobile-font-size);
    line-height: var(--cat-theme-typography-title-mobile-line-height);
  }
}
cat-text-passage[size=xs] .cat-c-status-list,
.cat-text-passage--xs .cat-c-status-list {
  margin-inline-start: 0;
  list-style: none;
  text-align: start;
}
cat-text-passage[size=xs] .cat-c-status-list span,
.cat-text-passage--xs .cat-c-status-list span {
  color: var(--cat-theme-color-content-default);
  font-weight: var(--cat-font-weight-semibold);
}
cat-text-passage[size=xs] .cat-c-status-list__item,
.cat-text-passage--xs .cat-c-status-list__item {
  position: relative;
}
cat-text-passage[size=xs] .cat-c-status-list__item:before,
.cat-text-passage--xs .cat-c-status-list__item:before {
  content: "";
  display: inline-block;
  margin-inline-end: var(--cat-space-x-small);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: red;
  position: relative;
  inset-block-start: -1px;
}
cat-text-passage[size=xs] .cat-c-status-list__item--information:before,
.cat-text-passage--xs .cat-c-status-list__item--information:before {
  background-color: var(--cat-theme-color-content-utility-information);
}
cat-text-passage[size=xs] .cat-c-status-list__item--success:before,
.cat-text-passage--xs .cat-c-status-list__item--success:before {
  background-color: var(--cat-theme-color-content-utility-success);
}
cat-text-passage[size=xs] .cat-c-status-list__item--warning:before,
.cat-text-passage--xs .cat-c-status-list__item--warning:before {
  background-color: var(--cat-theme-color-content-utility-warning);
}
cat-text-passage[size=xs] .cat-c-status-list__item--error:before,
.cat-text-passage--xs .cat-c-status-list__item--error:before {
  background-color: var(--cat-theme-color-content-utility-error);
}

/**
* Inverted text passage
* 1) Class names are needed to allow variant to work in React wrapper when attributes
* are removed
*/
cat-text-passage[inverted],
.cat-text-passage--inverted {
  color: var(--cat-theme-color-content-knockout);
  /**
  * Blockquote within inverted text passage
  */
}
cat-text-passage[inverted] blockquote,
.cat-text-passage--inverted blockquote {
  border-inline-start-color: var(--cat-theme-color-content-knockout-brand);
  color: var(--cat-theme-color-content-knockout-brand);
}

/**
 * !!! DO NOT WRITE ANY STYLE IN THIS FILE for styling specific elements within text passage.
 * Write it in text-passage-light-dom.scss to for styling.!!!
 */
.cat-c-text-passage {
  overflow: var(--cat-text-passage-overflow, visible);
  max-height: var(--cat-text-passage-max-height, none);
  /**
  * Only apply vertical for spacing stacked passages after the first one
  * as to not leave a trailing margin-bottom space.
  */
}
.cat-c-text-passage + * {
  margin-block-start: var(--cat-space-medium);
}
`;
       